import React from "react";
import Image from "components/image";
import clsx from "clsx/lite";

const ReferFriendBanner = ({ data }) => (
	<div className="w-full flex justify-center px-0 standard-section-width m-auto xl:pb-8">
		<div className="w-full flex bg-black h-60 md:h-auto relative">
			<div className={
				clsx("flex flex-col px-4 py-12 md:px-10 gap-3 max-w-full lg:w-1/2 absolute",
					"md:relative z-10 h-full bg-gradient-to-r from-black via-opacity-30")}>
				<div className="flex flex-col gap-2">
					{data?.title && <h2 className="text-white">{data.title}</h2>}
					{data?.subtitle && <p className="text-sm text-white">{data.subtitle}</p>}
				</div>
				<div className="flex">
					<button className="btn-secondary w-auto" data-lion-refer>Refer a Friend</button>

				</div>
			</div>
			<Image image={data.desktopImage} className="!hidden md:!block md:w-1/2" />
			<Image image={data.mobileImage} className="md:!hidden" />
		</div>
	</div>
);

export default ReferFriendBanner;